import React from "react";
import { Lock, Globe2, Target, Award } from "lucide-react";

const FEATURES = [
  {
    icon: Lock,
    title: "Private & Discreet",
    desc: "Confidentiality is operational protocol. Every engagement is handled with absolute discretion.",
  },
  {
    icon: Globe2,
    title: "Global Network",
    desc: "Access to a curated network of specialists, analysts and operators across jurisdictions.",
  },
  {
    icon: Target,
    title: "Strategic Focus",
    desc: "We do not sell deliverables. We engineer outcomes through deliberate, considered strategy.",
  },
  {
    icon: Award,
    title: "Results Driven",
    desc: "Every operation is measured against a single standard — verifiable, material impact.",
  },
];

export const WhyCamo = () => {
  return (
    <section
      id="why-camo"
      data-testid="why-camo-section"
      className="relative bg-black text-white py-24 md:py-32 lg:py-40 border-t border-zinc-900"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-zinc-600" />
              <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase text-zinc-400">
                Why CAMO
              </span>
            </div>
            <h2 className="font-display font-light uppercase leading-[1] tracking-tight text-4xl sm:text-5xl md:text-6xl">
              A Different<br />Approach
            </h2>
            <p className="mt-10 font-sans text-base md:text-lg text-zinc-400 leading-relaxed">
              Most agencies sell services.
            </p>
            <p className="mt-4 font-sans text-base md:text-lg text-zinc-400 leading-relaxed">
              CAMO provides access to operational capabilities.
            </p>
            <p className="mt-4 font-sans text-base md:text-lg text-zinc-400 leading-relaxed">
              Instead of hiring multiple providers, members gain access to a
              unified framework for growth, intelligence and protection.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-zinc-900">
            {FEATURES.map(({ icon: Icon, title, desc }) => (
              <div
                key={title}
                data-testid={`why-feature-${title.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="bg-black p-8 md:p-10 hover:bg-zinc-950 transition-colors duration-500 min-h-[220px]"
              >
                <Icon size={26} strokeWidth={1} className="text-white mb-6" />
                <h3 className="font-display font-light text-xl md:text-2xl uppercase tracking-tight">
                  {title}
                </h3>
                <p className="mt-3 font-sans text-sm text-zinc-400 leading-relaxed">
                  {desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyCamo;
